import { requestOrThrow } from '../api-client'
import type {
  ApplyByLoanAplusRequestParam,
  CompletedOrder,
  CreateApplicationUrlByLoanJaccsRequestParam,
  CreateApplicationUrlByLoanJaccsResopnseParam,
  CreatePaymentUrlByPayeasyResopnseParam,
  CreatedOrder,
  OrderCreateRequestParam,
  PaypayUrlResponse,
} from '../order-entry'

export function createOrderEntry(params: OrderCreateRequestParam) {
  return requestOrThrow<CreatedOrder>('orders', {
    method: 'POST',
    headers: {
      'X-STORE-ID-ALIAS': params.storeIdAlias,
    },
    query: {
      // 代理会計の宛先(対象者)。未指定=操作者自身。宛先不一致は 403(E_ACCOUNT_MISMATCH)。
      ...(params.targetGroupMemberId != null
        ? { targetGroupMemberId: params.targetGroupMemberId }
        : {}),
    },
    body: {
      name: params.name,
      isLoanAvailable: params.isLoanAvailable,
      details: [
        {
          name: params.name,
          amount: params.amount,
          isInsurable: false,
          quantity: 1,
        },
      ],
      calculationBase: params.calculationBase,
      subtotalAmount: params.subtotalAmount,
      taxAmount: params.taxAmount,
      totalAmount: params.totalAmount,
    },
  })
}

export function payOrderByCreditCard(orderId: number, targetGroupMemberId?: number) {
  return requestOrThrow<CompletedOrder>(`orders/${orderId}/pay/credit_card`, {
    method: 'POST',
    // 代理会計の宛先。未指定=操作者自身。宛先不一致は backend が 404 に縮退する。
    query: targetGroupMemberId != null ? { targetGroupMemberId } : undefined,
  })
}

export function createOrderPaypayUrl(orderId: number, targetGroupMemberId?: number) {
  return requestOrThrow<PaypayUrlResponse>(`orders/${orderId}/pay/paypay/url`, {
    method: 'POST',
    query: targetGroupMemberId != null ? { targetGroupMemberId } : undefined,
  })
}

export function createOrderPayeasyUrl(orderId: number, targetGroupMemberId?: number) {
  return requestOrThrow<CreatePaymentUrlByPayeasyResopnseParam>(
    `orders/${orderId}/pay/payeasy/url`,
    {
      method: 'POST',
      skipConvertKeyRecursivelyOnResponse: true,
      query: targetGroupMemberId != null ? { targetGroupMemberId } : undefined,
    }
  )
}

export function createOrderLoanJaccsApplicationUrl(
  orderId: number,
  body?: CreateApplicationUrlByLoanJaccsRequestParam,
  targetGroupMemberId?: number
) {
  return requestOrThrow<CreateApplicationUrlByLoanJaccsResopnseParam>(
    `orders/${orderId}/apply/loan_jaccs/url`,
    {
      method: 'POST',
      skipConvertKeyRecursivelyOnResponse: true,
      body,
      query: targetGroupMemberId != null ? { targetGroupMemberId } : undefined,
    }
  )
}

export function applyOrderLoanAplus(
  orderId: number,
  body?: ApplyByLoanAplusRequestParam,
  targetGroupMemberId?: number
) {
  return requestOrThrow<{ orderNumber: string }>(`orders/${orderId}/apply/loan_aplus`, {
    method: 'POST',
    body,
    query: targetGroupMemberId != null ? { targetGroupMemberId } : undefined,
  })
}
